import styled, { keyframes, css } from "styled-components";
import ChecklistSVG from "core/icons/checklist/circled_checklist.svg?react";
import CrossSVG from "core/icons/cross/cross2.svg?react";
import WarningSVG from "core/icons/false_flag.svg?react";
import ExclamationSVG from "core/icons/exclamation/exclamation-circle.svg?react";
import DangerSvg from "core/icons/exclamation/exclamation.svg?react";
import { Breakpoints } from "core/constants";

export const fadein = keyframes`
  from {
    right: 0;
    opacity: 0;
  }

  to {
    right: 20px;
    opacity: 1;
  }
`;

export const fadeout = keyframes`
  from {
    right: 20px;
    opacity: 1;
  }

  to {
    right: 0;
    opacity: 0;
  }
`;

const showStyle = ({ show, delay }: { show?: boolean; delay?: number }) =>
  show &&
  delay &&
  css`
    visibility: visible;
    animation: ${({
      // @ts-expect-error TS(2339): Property 'delayable' does not exist on type 'Theme... Remove this comment to see the full error message
      delayable,
    }) => delayable && `${fadein} 0.3s, ${fadeout} 0.3s ${delay / 1000}s`};
  `;

export const Container = styled.div<{
  show?: boolean;
  delay?: number;
  type?: "success" | "error" | "warning";
}>`
  display: flex;
  visibility: hidden;
  align-items: center;
  position: fixed;
  padding: 16px;
  left: 24px;
  bottom: 24px;
  border-radius: 10px;
  z-index: 99999;
  background-color: white;
  box-shadow: ${({ type, theme }) => {
    switch (type) {
      case "error":
        return theme?.colors?.snackbar.shodowAttention;
      case "warning":
        return theme?.colors?.snackbar.shadowWarning;
      default:
        return theme?.colors?.snackbar.shadowSuccess;
    }
  }};

  @media all and (max-width: ${Breakpoints.mobile3}px) {
    bottom: 96px;
    top: initial;
    width: calc(100% - 32px);
    right: 16px;
  }

  ${showStyle}
`;

export const Checklist = styled(ChecklistSVG)`
  margin-right: 10px;
  flex-shrink: 0;
`;

export const Danger = styled(DangerSvg)`
  margin-right: 10px;
  height: 24px;
  width: 24px;
  flex-shrink: 0;

  path {
    stroke: ${({ theme }) => theme.colors.danger.default};
  }
`;

export const Cross = styled(CrossSVG)`
  cursor: pointer;
  margin-left: 13px;
  margin-top: 1.5px;

  @media all and (max-width: ${Breakpoints.mobile3}px) {
    margin-left: auto;
  }
`;

export const NotificationText = styled.strong`
  font-family: Nunito-Sans;
  margin-top: 3px;
  font-size: 16px;
  line-height: 24px;
`;

export const SuccessOption = styled.p`
  cursor: pointer;
  font-weight: 700;
  line-height: 20px;
  font-size: 16px;
  color: ${({ theme }) => theme?.colors?.primary.default};
  text-transform: uppercase;
  margin-bottom: 0px;
  margin-left: 24px;
  margin-top: 3px;
`;

export const Exclamation = styled(ExclamationSVG)`
  margin-right: 10px;
  flex-shrink: 0;
`;

export const RightMessage = styled.p`
  cursor: pointer;
  font-weight: 700;
  line-height: 24px;
  font-size: 16px;
  color: ${({ theme }) => theme?.colors?.secondary.default};
  margin-bottom: 0px;
  text-align: end;
  margin-left: auto;

  @media all and (max-width: ${Breakpoints.mobile3}px) {
    font-size: 12px;
    line-height: 20px;
  }
`;
